import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { debounce } from "lodash";

import SearchBar from "components/SearchBar";
import { useDictionary } from "hooks";
import { findOrganizations } from "utils";
import { picklistsSelectors } from "store/selectors";


const OrgSearchInput = ({ onChange, value, ...rest }) => {
	const dictionary = useDictionary("budgetBuilder.components.OrgFinderInput");

	const { options: organizations } = useSelector(picklistsSelectors.organizations);

	const [ options, setOptions ] = useState(organizations);
	const [ isFetchingOptions, setIsFetchingOptions ] = useState(false);

	const doSearch = useMemo(() => debounce(
		searchText => {
			if (!!searchText) {
				setIsFetchingOptions(true);

				findOrganizations(searchText)
					.then(options => {
						setOptions(options);
						setIsFetchingOptions(false);
					});
			}
		},
		300,
	), []);

	useEffect(() => {
		return () => doSearch.cancel();
	}, [ doSearch ]);

	const onOpen = () => setOptions(organizations);

	return (
		<SearchBar
			loading={isFetchingOptions}
			options={options}
			onChange={(e, { value }) => onChange(value)}
			onSearchChange={(e, { searchQuery }) => doSearch(searchQuery)}
			value={value}
			placeholder={dictionary.label}
			selectOnBlur={false}
			onOpen={onOpen}
			{...rest}
		/>
	);
};

export default OrgSearchInput;
